import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import lv from './lv.json';
import ru from './ru.json';
import de from './de.json';
import es from './es.json';
import est from './est.json';
import fr from './fr.json';
import lt from './lt.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      lv: { translation: lv },
      ru: { translation: ru },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      est: { translation: est },
      lt: { translation: lt }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
